﻿export const divaContracts = (state) => {     
    return state.contracts.divaContracts;
}

export const signedPortings = (state) => {     
    return state.contracts.signedPortings;
}